module.exports = __webpack_public_path__ + "img/ends_en.c8286da2.png";